/** Internal helper imports here ... */

import infinite from 'infinite-scroll';

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
export default (() => {
  const init = () => {
    const elem = document.querySelector('ul.products');
    let infScroll = new InfiniteScroll(elem, {
      // options
      path: 'a.page-numbers',
      append: 'li.alm-item',
      history: false,
      status: '.page-load-status',
      scrollThreshold: 200,
      hideNav: '.pagination'
    });
  };

  return {
    init
  };
})();
